import PropTypes from 'prop-types';
import React from 'react';
import ReactHighlightWords from 'react-highlight-words';
import { getSecondaryColorNumbers } from '../../services/get-colors';
import styles from './highlighter.scss';

const STYLE = {
  backgroundColor: `rgba(${getSecondaryColorNumbers()}, 0.3)`,
};

const Highlighter = ({ text, query }) =>
  <ReactHighlightWords
    highlightClassName={styles.mark}
    highlightStyle={STYLE}
    textToHighlight={text}
    searchWords={query.split(' ')}
  />;

Highlighter.propTypes = {
  text: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
};

export default Highlighter;



// WEBPACK FOOTER //
// ./app/components/highlighter/highlighter.js